
  import { ResetPasswordCommand } from '@/apiclient/apiclient_generated';
  import { NotificationService } from '@/services/notification-service';
  import { AccountModule, AccountStore } from '@/store/account';
  import Routes from '@/types/Routes';
  import { Options, Vue } from 'vue-class-component';

  @Options({})
  export default class ResetPassword extends Vue {
    private accountStore: AccountModule = AccountStore;

    email = '';
    isLoading = false;

    login() {
      this.$router.push(Routes.root.path);
    }

    async reset() {
      this.isLoading = true;
      const command = {
        email: this.email
      } as ResetPasswordCommand;

      const result = await this.accountStore.resetPassword(command);

      this.isLoading = false;

      if (result.isSuccess) {
        NotificationService.NotifySuccess('Password has been successfully reset');
        this.$router.push(Routes.root.path);
      } else {
        NotificationService.NotifyErrors(result.errors);
      }
    }
  }
